import * as React from 'react';
import { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { Trans, useTranslation } from 'react-i18next';
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from "dayjs/plugin/customParseFormat";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import lastDate18YearsAgo from '../../../hooks/lastDate18years';
import { ESex, IRegisterCompnyModel} from '../../../models/authmodels';
import { useSearchParams } from 'react-router-dom';
import { registerCompany } from '../../../hooks/auth/actions';
import SearchNations from './searchNation';
import { delay } from '../../../utilities/delay';
import settings from '../../../utilities/settings';
import DropDownLanguages from '../../DropDownLanguages';
import SelectType from './selectType';
import Checkbox from '@mui/material/Checkbox';
import { BLUE_DARK, GREEN_LOGO } from '../../../theme/colors';
import styled from '@emotion/styled';
import SexSelect from '../../DropDownSex';
import { useTheme,useMediaQuery } from '@mui/material';
import PasswordToggleIcon from '../../PasswordToggleIcon';
import { isMobile } from 'react-device-detect';
import { assobayLegalLinkProps } from '../../../helpers/assobayLegalLinks';

const ACustom = styled('a')(({theme})=>({
    cursor: 'pointer', 
    color:BLUE_DARK, 
    textDecoration: 'none',
    ':hover':{
        textDecoration: 'underline',
        fontWeight: 'bold',
        transition: 'color 0.3s, textDecoration 0.3s',
    }                          
}))

export default function RegisterCompanyAssociation() {
    dayjs.extend(customParseFormat);
    const { t } = useTranslation();
    const [searchParams] = useSearchParams(); // parametri url

    const UserRef = searchParams.get("UserRef") as string;
    const typeParam = searchParams.get("Type");
    let Type: number;

    if (typeParam === "1" || typeParam === "2") {
        Type = parseInt(typeParam, 10);
    } else {
        Type = 1;
    }
    const ReturnUrl = searchParams.get("ReturnUrl") !== null ? searchParams.get("ReturnUrl") as string : "/account/confirm-mail"
    
    // ADMIN
    const [selectedDate, setSelectedDate] = useState<Dayjs | null>(); //dayjs(lastDate18YearsAgo())
    const [bornError, setBornError] = useState(false);
    const [bornErrorMessage, setBornErrorMessage] = useState('');
    const [maxData, setMaxData] = useState<Dayjs | null>(dayjs(lastDate18YearsAgo()));
    
    const [name, setName] = useState('');
    const [nameError, setNameError] = useState(false);
    
    const [surname, setSurname] = useState('');
    const [surnameError, setSurnameError] = useState(false);

    const [codfisc, setCodFisc] = useState('');
    const [codfiscError, setCodFiscError] = useState(false);

    // SOCIETA' O ASSOCIAZIONE
    const [nameCompany, setNameCompany] = useState('');
    const [nameCompanyError, setNameCompanyError] = useState(false);

    const [codfiscCompany, setCodFiscCompany] = useState('');
    const [codfiscCompanyError, setCodFiscCompanyError] = useState(false);

    const [vat, setVat] = useState('');
    const [vatError, setVatError] = useState(false);

    const [indirizzo, setIndirizzo] = useState('');
    const [indirizzoError, setIndirizzoError] = useState(false);

    const [citta, setCitta] = useState('');
    const [cittaError, setCittaError] = useState(false);

    const [cap, setCap] = useState('');
    const [capError, setCapError] = useState(false);

    const [nazione, setNazione] = useState<string | null>('');
    const [nazioneError, setNazioneError] = useState(false);
    
    const [provincia, setProvincia] = useState('');
    const [provinciaError, setProvinciaError] = useState(false);

    const [mail, setMail] = useState('');
    const [mailError, setMailError] = useState(false);

    const [password, setPassword] = useState('');
    const [passwordError, setPasswordError] = useState(false);
    const [passwordErrorMessage, setPasswordErroMessage] = useState('');

    const [showPassword, setShowPassword] = useState(false);

    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordConfirmError, setPasswordConfirmError] = useState(false);
    const [passwordConfirmErrorMessage, setPasswordConfirmErroMessage] = useState('');
    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false); // toggle password (occhiolino)

    const [genericMessage, setGenericMessage] = useState(false)
    const [genericMessageIsError, setGenericMessageIsError] = useState(false)
    const [genericMessageText, setGenericMessageText] = useState('')

    const [sex, setSex] = useState<ESex>(ESex.Male);
    const [sexError, setSexError] = useState(false);

    const [checkBox, setCheckBox] = useState(false);

    const [type, setType] = useState(Type); //1=ASSOCIAZIONE 2=AZIENDA come da Enum Server

    const [isSubmit, setIsSubmit] = useState(false);

    const minPasswordLength = 8;

    useEffect(()=>{
        window.scrollTo(0,0)
    },[])
    
    useEffect(()=>{
        //  // reset messaggio errore generico
        //  setGenericMessage(false)
        //  setGenericMessageIsError(false)
        //  setGenericMessageText('')
        //  console.log(selectedDate, name, vat, surname, nameCompany, indirizzo, citta, cap, nazione, provincia, password, confirmPassword, mail, type, codfiscCompany)
    },[selectedDate, name, vat, surname, nameCompany, indirizzo, citta, cap, nazione, provincia, password, confirmPassword, mail, type, codfiscCompany])


    function removeFirstSpaceChar(str:string) {
        if (str.charAt(0) === ' ') {
          return str.slice(1);
        } else {
          return str;
        }
      }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, key:string) => {
        setGenericMessage(false)
        setGenericMessageIsError(false)
        setGenericMessageText('')
        switch(key){
            case 'name': {
                const value = removeFirstSpaceChar(e.target.value)
                const regex = new RegExp("^[\\p{L}\\p{M} \\-']+$", "u")
                const isValid = regex.test(value)
                setName(value);
                if (isValid) {
                    setNameError(false);
                } else {
                    if( value === '' ){
                        setNameError(false);
                    }else{
                        setNameError(true);
                    }   
                }
            } break
            case 'surname': {
                const value = removeFirstSpaceChar(e.target.value)
                const regex = new RegExp("^[\\p{L}\\p{M} \\-']+$", "u")
                const isValid = regex.test(value)
                setSurname(value);
                if (isValid) {
                    setSurnameError(false);
                } else {
                    if( value === '' ){
                        setSurnameError(false);
                    }else{
                        setSurnameError(true);
                    }   
                }
            } break
            case 'companyname': {
                const value = removeFirstSpaceChar(e.target.value)
                const regex = new RegExp("^[\\p{L}\\p{N}\\p{M}\\p{P}\\p{Z}\\p{S} \\-']+$", "u")
                const isValid = regex.test(value)
                setNameCompany(value);
                if (isValid) {
                    setNameCompanyError(false);
                } else {
                    if( value === '' ){
                        setNameCompanyError(false);
                    }else{
                        setNameCompanyError(true);
                    }   
                }
            } break
            case 'password':{
                const value = removeFirstSpaceChar(e.target.value)

                setPassword(e.target.value)
                setPasswordError(false);
                setPasswordErroMessage("");
            } break
            case 'confirmPassword':{
                setConfirmPassword(e.target.value)
                setPasswordConfirmError(false)
                setPasswordConfirmErroMessage('')
            }break
            case 'indirizzo': {
                const value = removeFirstSpaceChar(e.target.value)
                const regex = new RegExp("^[\\p{L}\\p{N}\\p{M}\\p{P}\\p{Z}\\p{S} ,\\.\\-\\/]+$", "u")
                const isValid = regex.test(value)
                setIndirizzo(value);
                if (isValid) {
                    setIndirizzoError(false);
                } else {
                    if( value === '' ){
                        setIndirizzoError(false);
                    }else{
                        setIndirizzoError(true);
                    }   
                }
            } break
            case 'citta': {
                const value = removeFirstSpaceChar(e.target.value)
                const regex = new RegExp("^[\\p{L}\\p{M} \\-']+$", "u")
                const isValid = regex.test(value)
                setCitta(value);
                if (isValid) {
                    setCittaError(false);
                } else {
                    if( value === '' ){
                        setCittaError(false);
                    }else{
                        setCittaError(true);
                    }   
                }
            } break
            case 'cap': {
                const value = removeFirstSpaceChar(e.target.value)
                const regex = /^[0-9]+$/
                const isValid = regex.test(value)
                setCap(value);
                if (isValid) {
                    setCapError(false);
                } else {
                    if( value === '' ){
                        setCapError(false);
                    }else{
                        setCapError(true);
                    }   
                }
            } break
            case 'nazione': {
                const value = removeFirstSpaceChar(e.target.value)
                const regex = new RegExp("^[\\p{L}\\p{M} \\-']+$", "u")
                const isValid = regex.test(value)
                setNazione(value);
                if (isValid) {
                    setNazioneError(false);
                } else {
                    if( value === '' ){
                        setNazioneError(false);
                    }else{
                        setNazioneError(true);
                    }   
                }
            } break
            case 'provincia': {
                let value = removeFirstSpaceChar(e.target.value)
                const regex = new RegExp("^[\\p{L} \\-']{2,50}$", "u")
                const isValid = regex.test(value)
                if (value)
                    value = value.toUpperCase()
                setProvincia(value);
                if (isValid) {
                    setProvinciaError(false);
                } else {
                    if( value === '' ){
                        setProvinciaError(false);
                    }else{
                        setProvinciaError(true);
                    }   
                }
            } break
            case 'email': {
                let value = removeFirstSpaceChar(e.target.value)
                const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                const isValid = regex.test(value)
                setMail(value)
                if(isValid){
                    setMailError(false)
                } else {
                    setMailError(true)
                }
            }break
            case 'codfisc': {
                const value = removeFirstSpaceChar(e.target.value)
                const regex = /^[A-Za-z0-9]*$/
                const isValid = regex.test(value)
                setCodFisc(value);
                if (isValid) {
                    setCodFiscError(false);
                } else {
                    if( value === '' ){
                        setCodFiscError(false);
                    }else{
                        setCodFiscError(true);
                    }   
                }
            } break
            case 'codfisccompany': {
                const value = removeFirstSpaceChar(e.target.value)
                const regex = /^[A-Za-z0-9]*$/
                const isValid = regex.test(value)
                setCodFiscCompany(value);
                if (isValid) {
                    setCodFiscCompanyError(false);
                } else {
                    if( value === '' ){
                        setCodFiscCompanyError(false);
                    }else{
                        setCodFiscCompanyError(true);
                    }   
                }
            } break
            case 'vat': {
                const value = removeFirstSpaceChar(e.target.value)
                const regex = /^[A-Za-z0-9]*$/
                const isValid = regex.test(value)
                setVat(value);
                if (isValid) {
                    setVatError(false);
                } else {
                    if( value === '' ){
                        setVatError(false);
                    }else{
                        setVatError(true);
                    }   
                }
            } break
        }
    };

    const handlePasswordCheckOnBlur = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const pwRegex = /^(?=.*[a-zàèìòùáéíóúäëïöüßçñ])(?=.*[A-ZÀÈÌÒÙÁÉÍÓÚÄËÏÖÜÇÑ])(?=.*[0-9])(?=.*[!@#$%^&*()[\]{}\-_+=<>,.?/\\|])[^\s]+$/
        const isValid = pwRegex.test(e.target.value)
        if (e.target.value.length < minPasswordLength){
            setPasswordError(true)
            setPasswordErroMessage(`La password deve contenere almeno ${minPasswordLength} caratteri`)
            return
        }
        if(!isValid)
        {
                setPasswordError(true);
                setPasswordErroMessage(`Password non valida! Deve contenere almeno 1 maiuscola, 1 minuscola, 1 carattere speciale e 1 numero e non avere spazi`)
        }else{
            setPasswordError(false)
            setPasswordErroMessage("")
        }
    }

    const handleConfirmPasswordCheckOnBlur = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        if (password !== confirmPassword){ 
            setPasswordConfirmError(true);
            setPasswordConfirmErroMessage(`Le password non corrispondono`)
        }else{
            setPasswordConfirmError(false);
            setPasswordConfirmErroMessage(``);
        }
    }

    const handleChangeDate = (date: Dayjs | null) => {
        setBornErrorMessage('')
        if(date !== null && date.isValid()){ // se la data è valida mi setti false, ma se per caso dovesse essere meno di 18 anni fai true all'errore
            setSelectedDate(date)
            setBornError(false)

            if(maxData !== null && date > maxData){
                setBornErrorMessage(t("Devi avere più di 18 anni per iscriverti"))
                setBornError(true)
            } 
        } 
        if (date !== null && !date.isValid()){
            setBornErrorMessage(t("Data non valida"))
            setBornError(true)
        }
    };

    const isFormCorrect = ( 
        name === '' || 
        surname === '' ||
        indirizzo === '' ||
        citta === '' ||
        cap === '' ||
        nazione === '' ||
        provincia === '' ||
        password === '' ||
        nameCompany === "" || 
        codfiscCompany === "" ||
        password !== confirmPassword ||
        mail === '' ||
        !checkBox ||
        codfisc === '' // vat no perchè non obbligatorio 
    ) ? false : true

    function checkAreNotEmpies(): boolean {
        let areCorrects = true;
        // reset messaggio errore generico
        setGenericMessage(false)
        setGenericMessageIsError(false)
        setGenericMessageText('')

        //check con set degli errori singoli
        if(name === '') {setNameError(true); areCorrects = false}
        if(surname === '') {setSurnameError(true); areCorrects = false}
        if(indirizzo === '') {setIndirizzoError(true); areCorrects = false}
        if(citta === '') {setCittaError(true); areCorrects = false}
        if(cap === '') {setCapError(true); areCorrects = false}
        if(nazione === null || nazione === "") {setNazioneError(true); areCorrects = false}
        if(provincia === '') {setProvinciaError(true); areCorrects = false}
        if(password === '') {setPasswordError(true); areCorrects = false}
        if(password !== confirmPassword) {setPasswordConfirmError(true); setPasswordConfirmErroMessage("Le password non corrispondono"); areCorrects = false}
        if(nameCompany === '') {setNameCompanyError(true); areCorrects = false}
        if(mail === '') {setMailError(true); areCorrects = false}
        if(codfisc === '') {setCodFiscError(true); areCorrects = false}
        if(codfiscCompany === '') {setCodFiscCompanyError(true); areCorrects = false}
        if(sex === null || sex === undefined) {setSexError(true); areCorrects = false}
        
        if (!areCorrects) {
            setGenericMessage(true)
            setGenericMessageIsError(true)
            setGenericMessageText(t("Ci sono degli errori nel form"))
        }else{
            if(!checkBox) {setCodFiscCompanyError(true); areCorrects = false}
        
            if (!areCorrects) {
                setGenericMessage(true)
                setGenericMessageIsError(true)
                setGenericMessageText(t("Non hai accettato i termini e le condizioni"))
            }
        }
        
        return areCorrects;
    }
    
    function inputClean(){
        setName("")
        setSurname('')
        setCap('')
        setSelectedDate(dayjs(lastDate18YearsAgo()))
        setNameCompany('')
        setIndirizzo('')
        setCitta('')
        setNazione(null)
        setProvincia('')
        setMail('')
        setPassword('')
        setConfirmPassword('')
        setCodFisc('')
        setVat('')
        setCodFiscCompany('')
        setType(0)
        setSex(ESex.Male)
    } 

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setGenericMessage(false)
        setGenericMessageIsError(false)
        setGenericMessageText('')
        // verifico che non abbia errori in memoria
        if( !bornError && 
            !nameError && 
            !surnameError &&
            !codfiscCompanyError &&
            !indirizzoError &&
            !cittaError &&
            !capError &&
            !nazioneError &&
            !provinciaError &&
            !passwordError &&
            !passwordConfirmError &&
            !nameCompanyError &&
            !codfiscError && 
            !vatError &&
            !mailError &&
            !sexError// verificare
        ){
            const areCorrects = checkAreNotEmpies();
            if(!areCorrects) return;

            setIsSubmit(true)
            // se tutto va bene:
            const regModel: IRegisterCompnyModel = {
                email: mail,
                password: password,
                returnUrl: ReturnUrl,
                name: name,
                surname: surname,
                codFisc: codfisc,
                born: selectedDate ? new Date(Date.UTC(selectedDate.year(), selectedDate.month(), selectedDate.date())) : new Date(),
                indirizzo: indirizzo,
                citta: citta,
                cap: parseInt(cap),
                provincia: provincia,
                nazione:nazione ? nazione : '',
                nameCompany: nameCompany,
                codFiscCompany: codfiscCompany,
                partitaIva: vat,
                type: type,
                confirm:checkBox,
                userRef: UserRef,
                sex: sex
            };

            console.log(regModel)

            await registerCompany(regModel).then(response => {
                setIsSubmit(false)
                setGenericMessage(true)
                setGenericMessageIsError(false)
                const message = "Registrazione avvenuta con successo! Approva la mail che ti abbiamo inviato per concludere la procedura!"
                setGenericMessageText(t(message))
                inputClean()
                if(searchParams.get("ReturnUrl") !== null){
                    delay(5000).then(r=>{
                        const message = "Stai per essere reindirizzato alla pagina di provenienza..."
                        setGenericMessageText(t(message));
                    }).finally(()=>{ 
                        delay(5000).then(rr=>{
                            return window.location.href = ReturnUrl;
                        })
                    })
                    
                }else{
                    return window.location.href = ReturnUrl+"?userName="+response.userName;
                }
                
            }).catch(e=>{
                setIsSubmit(false)
                console.log("REGISTER ERROR", e)
                setGenericMessage(true)
                setGenericMessageIsError(true)
                const message:any = e?.response?.data || e?.response || e || "Errore durante la registrazione. Riprova più tardi."
                setGenericMessageText(t(message))
            })
        }else{
            setGenericMessage(true)
            setGenericMessageIsError(true)
            setGenericMessageText(t("Ci sono degli errori nel form"))
        }
    };
  
    const theme = useTheme();
    const isXs = useMediaQuery(theme.breakpoints.only('xs'));

    return (
        <Container component="main" maxWidth="xs" sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            border:'1px solid rgb(128, 128, 128, 0.35)',
            margin:'30px 0px 30px 0px',
            borderRadius:'5px'
        }}
        >
            <Box
                sx={{
                    padding:'8px 0 0 0',
                    width:'100%',
                    height:'35px',
                    marginBottom:'30px',
                    display:'flex'
                }}
            >
                <Box sx={{
                    padding:'0px',
                    width:'100px',
                    display:'flex',
                    justifyContent:'start',
                    alignItems:'center'
                }}>
                    <img src={"/"+settings.Details.Logo} alt="Plutima Provider" style={{
                        height:'35px',
                        marginTop:'8px'
                    }}/>
                </Box>
                <Box sx={{
                    padding:'0px',
                    flex:1,
                    display:'flex',
                    justifyContent:'end',
                    alignItems:'center'
                }}>
                    <DropDownLanguages />
                </Box>
            </Box>

            <Avatar sx={{ m: 1, width: 70, height: 70, backgroundColor: GREEN_LOGO, color: 'white', alignItems:'center' }}>
                <LockOutlinedIcon sx={{fontSize:50}}/>
            </Avatar>

            <Box
                sx={{
                    height: 10,
                }}
            />

            <Typography component="h1" variant="h5">
                {t('Registrati come Associazione o Attività economica')}
            </Typography>

            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                
                {/* <Typography variant='body1' sx={{marginTop:'30px'}}>{t("Sei una azienda o una associazione?")}</Typography> */}
                {/** Tipo registrazione */}
                <Typography sx={{
                    fontSize:'1em',
                    color:'grey',
                    marginBottom:"-8px",
                    paddingTop:"50px",
                    textAlign:'left'
                }}>{t("Voglio registrarmi come:")}</Typography>
                <SelectType setType={setType} type={type}/>
                
                {/* <Typography variant='body1' sx={{marginTop:'30px'}}>{t("Dati del legale rappresentante")}</Typography> */}
                {/** rappresentante */}
                <Typography sx={{
                    fontSize:'1em',
                    color:'grey',
                    marginBottom:"-8px",
                    paddingTop:"65px",
                    textAlign:'left'
                }}>{t("Dati del legale rappresentante")}</Typography>
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="name"
                    label={!nameError ? t('Nome'): t("Errore")}
                    name="name"
                    autoComplete="name"
                    autoFocus
                    value={name}
                    onChange={(event) => handleChange(event, 'name')}
                    error={nameError}
                    helperText={
                        nameError ? t("Campo Obbligatorio - Richieste lettere e spazi") : ""
                    }
                />

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="surname"
                    label={!surnameError ? t('Cognome') : t("Errore")}
                    name="surname"
                    autoComplete="surname"
                    autoFocus
                    value={surname}
                    onChange={(event) => handleChange(event, 'surname')}
                    error={surnameError}
                    helperText={
                        surnameError ? t("Campo Obbligatorio - Richieste lettere e spazi") : ""
                    }
                />

                <Grid container spacing={isXs ? 0 : 2}>
                    <Grid item xs={12} sm={3} sx={{
                        display:"flex",
                        alignItems:"center"
                    }}>
                        <SexSelect
                            sex={sex}
                            setSex={setSex}
                            sexError={sexError}
                            setSexError={setSexError}
                            />
                    </Grid>
                    <Grid item xs={12} sm={9}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <Stack sx={{
                                marginTop:'16px',
                                marginBottom:'8px'
                            }}>
                                {isMobile ? (
                                    <TextField
                                        fullWidth
                                        type="date"
                                        label={!bornError ? (t('Data di Nascita')) : t("Errore")}
                                        value={selectedDate ? selectedDate.format('YYYY-MM-DD') : ''}
                                        onChange={(e) => {
                                            const date = dayjs(e.target.value);
                                            if (date.isValid()) {
                                                handleChangeDate(date);
                                            }
                                        }}
                                        required
                                        id="born"
                                        error={bornError}
                                        helperText={bornErrorMessage}
                                        InputLabelProps={{ shrink: true }}
                                    />
                                ) : (
                                    <DatePicker
                                        format="DD/MM/YYYY" 
                                        label={!bornError ? (t('Data di Nascita')) : t("Errore")}
                                        views={['day', 'month', 'year']}
                                        value={selectedDate}
                                        onChange={(date) => {
                                            if (date !== null && date.isValid()) {
                                                const normalized = date.startOf('day');
                                                handleChangeDate(normalized);
                                            }
                                        }}
                                        autoFocus
                                        slotProps={{
                                            textField:{
                                                required: true,
                                                id: 'born',
                                                error: bornError,
                                                helperText: bornErrorMessage
                                            }
                                        }}
                                    />
                                )}
                            </Stack> 
                        </LocalizationProvider>
                    </Grid>
                </Grid>

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="codfisc"
                    label={!codfiscError ? t('Codice Fiscale'): t("Errore")}
                    name="codfisc"
                    autoComplete="codfisc"
                    autoFocus
                    value={codfisc}
                    onChange={(event) => handleChange(event, 'codfisc')}
                    error={codfiscError}
                    helperText={
                        codfiscError ? t("Campo Obbligatorio - Richiesti lettere e numeri") : ""
                    }
                />



                {/** "Dati dell'Associazione o dell'Attività economica" */}
                <Typography sx={{
                    fontSize:'1em',
                    color:'grey',
                    marginBottom:"-8px",
                    paddingTop:"65px",
                    textAlign:'left'
                }}>{t("Dati dell'Associazione o dell'Attività economica")}</Typography>
                {/* <Typography variant='body1' sx={{marginTop:'30px'}}>{t("Dati dell'azienda o dell'associazione")}</Typography>  */}
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="companyname"
                    label={!nameCompanyError ? t('Denominazione') : t("Errore")}
                    name="companyname"
                    autoComplete="companyname"
                    autoFocus
                    value={nameCompany}
                    onChange={(event) => handleChange(event, 'companyname')}
                    error={nameCompanyError}
                    helperText={
                        nameCompanyError ? t("Campo Obbligatorio - Richieste lettere e spazi e - ") : ""
                    }
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="indirizzo"
                    label={!indirizzoError ? t('Indirizzo') : t("Errore")}
                    name="indirizzo"
                    autoComplete="indirizzo"
                    autoFocus
                    value={indirizzo}
                    onChange={(event) => handleChange(event, 'indirizzo')}
                    error={indirizzoError}
                    helperText={
                        indirizzoError ? t("Richieste solo lettere, spazi, numeri, virgola e meno e /") : ""
                    }
                />

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="citta"
                    label={!cittaError ? t('Città'): t("Errore")}
                    name="citta"
                    autoComplete="citta"
                    autoFocus
                    value={citta}
                    onChange={(event) => handleChange(event, 'citta')}
                    error={cittaError}
                    helperText={
                        cittaError ? t("Campo Obbligatorio - Richieste lettere e spazi") : ""
                    }  
                />

                <Grid container spacing={2}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="cap"
                            label={!capError ? t('CAP'): t("Errore")}
                            name="cap"
                            autoComplete="cap"
                            autoFocus
                            type='number'
                            value={cap}
                            onChange={(event) => handleChange(event, 'cap')}
                            error={capError}
                            helperText={
                                capError ? t("Campo Obbligatorio - Richiesti solo Numeri") : ""
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            margin="normal"
                            required
                            fullWidth
                            id="provincia"
                            label={!provinciaError ? t('Provincia'): t("Errore")}
                            name="provincia"
                            autoComplete="provincia"
                            autoFocus
                            value={provincia}
                            onChange={(event) => handleChange(event, 'provincia')}
                            error={provinciaError}
                            helperText={
                                provinciaError ? t("Campo Obbligatorio - Richieste lettere") : ""
                            }
                            inputProps={{ maxLength: 5 }}
                        />
                    </Grid>
                </Grid>

                <SearchNations setNazione={setNazione} nazioneError={nazioneError} setNazioneError={setNazioneError} />

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="codfisccompany"
                    label={!codfiscCompanyError ? t('Codice Fiscale Azienda o Associazione'): t("Errore")}
                    name="codfisccompany"
                    autoComplete="codfisccompany"
                    autoFocus
                    value={codfiscCompany}
                    onChange={(event) => handleChange(event, 'codfisccompany')}
                    error={codfiscCompanyError}
                    helperText={
                        codfiscCompanyError ? t("Campo Obbligatorio - Richiesti lettere e numeri") : ""
                    }
                />

                <TextField
                    margin="normal"
                    // required
                    fullWidth
                    id="vat"
                    label={!vatError ? t('Partita Iva'): t("Errore")}
                    name="vat"
                    autoComplete="vat"
                    autoFocus
                    value={vat}
                    onChange={(event) => handleChange(event, 'vat')}
                    error={vatError}
                    helperText={
                        vatError ? t("Richiesti lettere e numeri") : ""
                    }
                />

                {/** "Dati dell'Associazione o dell'Attività economica" */}
                <Typography sx={{
                    fontSize:'1em',
                    color:'grey',
                    marginBottom:"-8px",
                    paddingTop:"65px",
                    textAlign:'left'
                }}>{t("Dati di autenticazione")}</Typography>
                
                {/* <Typography variant='body1' sx={{marginTop:'30px'}}>{t("Dati di autenticazione")}</Typography>  */}
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="email"
                    label={!mailError ? t('Indirizzo Email'): t("Errore")}
                    name="email"
                    autoComplete="email"
                    autoFocus
                    value={mail}
                    onChange={(event) => handleChange(event, 'email')}
                    error={mailError}
                    helperText={
                        mailError ? t("Inserisci un indirizzo email valido") : ""
                    }
                />

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label={!passwordError ? t('Password'): t("Errore")}
                    type={showPassword ? "text" : "password"}
                    id="password"
                    autoComplete="current-password"
                    onChange={(e) => handleChange(e, "password")}
                    error={passwordError}
                    onBlur={(e) => handlePasswordCheckOnBlur(e)} 
                    helperText={
                        passwordError ? t(passwordErrorMessage) : ""
                    }
                    InputProps={{
                        endAdornment: (
                            <PasswordToggleIcon
                                visible={showPassword}
                                onToggle={() => setShowPassword(prev => !prev)}
                                password={password}
                            />
                        ),
                    }}
                />

                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="confirmPassword"
                    label={!passwordConfirmError ? t('Conferma Password') : t("Errore") }
                    type={showPasswordConfirm ? "text" : "password"}
                    id="confirmPassword"
                    onChange={(e) =>  handleChange(e, 'confirmPassword')}
                    error={passwordConfirmError}
                    onBlur={(event) =>handleConfirmPasswordCheckOnBlur(event)} // faccio un check se la pw va bene quando esco
                    helperText={
                        passwordConfirmError ? t(passwordConfirmErrorMessage) : ""
                    }
                    InputProps={{
                        endAdornment: (
                            <PasswordToggleIcon
                                visible={showPasswordConfirm}
                                onToggle={() => setShowPasswordConfirm(prev => !prev)}
                                password={confirmPassword}
                            />
                        ),
                    }}
                />

                {/* <Typography variant='body1' sx={{marginTop:'30px'}}>{t("Accettazione dei termini e condizioni")}</Typography>  */}
                <Grid container sx={{margin:'16px 0 8px 0'}}>
                    <Grid item xs={1} sx={{
                        display:'flex',
                        justifyContent:'center',
                        alignItems:'center',
                        minHeight:'53px'
                    }}> 
                        <Checkbox
                            checked={checkBox}
                            onChange={()=> setCheckBox(!checkBox)}
                            name="termsandconditions"
                            color="primary"
                            sx={{padding:'0px'}}
                        />
                    </Grid>
                    <Grid item xs={11} sx={{
                        paddingLeft:'5px',
                        display:'flex',
                        flexDirection:'column',
                        justifyContent:'center',
                        alignItems:'center',
                        minHeight:'53px'
                    }}>
                        <Typography variant='inherit'
                            sx={{
                                marginTop: '-1px',
                                fontSize:'1em',
                                textAlign:'justify'
                            }}
                        >
                            {/* {t("ACCETTO dopo aver letto con attenzione tutti i ")} <ACustom onClick={()=>{console.log("il ciccio entra nel culo")}}>{t("Termini e Condizioni")}</ACustom> */}
                            <Trans i18nKey="accetto-registrazione-azienda-associazione" components={{
                                    terms: <a {...assobayLegalLinkProps('terms')} />,
                                    convenzioneAttEcon: <a {...assobayLegalLinkProps('convenzioneAttEcon')} />,
                                    convenzioneAssoc: <a {...assobayLegalLinkProps('convenzioneAssoc')} />,
                                    privacy: <a {...assobayLegalLinkProps('privacy')} />,
                                    cookie: <a {...assobayLegalLinkProps('cookie')} />
                                }}
                            />
                        </Typography>
                    </Grid>
                </Grid>

                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2 }}
                    disabled={isSubmit} 
                    // {!isFormCorrect || isSubmit}
                >
                    {t('Registrati')}
                </Button>

            </Box>

            { genericMessage && 
                <Box
                    sx={{
                        maxHeight: '200px',
                        overflow:'hidden',
                        textOverflow: 'ellipsis'
                    }}
                >
                    <Typography variant='h6'
                        sx={{color: genericMessageIsError ? "red" : "green"}}
                    >
                        { genericMessageText }
                    </Typography> 
                </Box>
            }

            <Box sx={{
                height: 40,
            }}/>
        </Container>
    )
}